import { host } from 'core-framework/window/location';

export const AppConfiguration = {
    isProduction: () => process.env.NODE_ENV === 'production',
    isDev: () => process.env.NODE_ENV === 'development' || VERSION === 'development',
    isMock: () => {
        return USE_MOCK_DATA ?? false;
    },
    isPreLive: () => {
        const hostName = host();
        return hostName.includes('.wgci.') || hostName.includes('.wgpl.');
    },
    version: VERSION || 'development',
    paypalClientId: PAYPAL_CLIENT_ID || 'AX4a1uGSo_9jYel65NODx6Uue1K8Ot_ly3XKGtQIylGgLk8vK1YbA4OZ19MNKNEr0k3ln8Pvu_oF4ibx',
    afterPaySDKSrc: AFTER_PAY_SDK_SRC || 'https://portal.sandbox.afterpay.com/afterpay.js',
};
